import { SensorStatus } from '../types/SensorStatus';

export const sensorStatusKeys: SensorStatus[] = [
  SensorStatus.IN,
  SensorStatus.OUT,
  SensorStatus.MEETING,
];
